import React from "react";
import apiClient from "api/client";
import {connect} from 'react-redux';
import {Redirect} from 'react-router'
import {userActions} from '../../authentication/_actions';
import Button from "../CustomButton/CustomButton.jsx";
import {Tooltip, OverlayTrigger, Badge, Grid, Row, Col} from 'react-bootstrap';
import ModalRestore from "../CustomModals/ModalRestore";
import ModalDelete from "../CustomModals/ModalDelete";
import {withNamespaces} from 'react-i18next';
import ReactTableV6Simple from "../CustomDataTables/ReactTableV6Simple";
import Card from "../Card/Card";

class DataRssFeeds extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            remove_tooltip: (<Tooltip id="remove_tooltip">Remove</Tooltip>),
            restore_tooltip: (<Tooltip id="restore_tooltip">Restore</Tooltip>),
            edit_tooltip: (<Tooltip id="edit_tooltip">Edit</Tooltip>),

            showRestoreModal: false,
            showDeleteModal: false,

            redirect: false,
            rss_feed_id: 1,
            loading: true,

            data: [],
            columns: [],

            mount: false
        };

    }

    setRedirect = () => {
        this.setState({
            redirect: true
        })
    }

    renderRedirect = () => {

        if (this.state.redirect) {
            let path = "/edit-rss/" + this.state.rss_feed_id;
            //console.log(path);
            return <Redirect push to={path}/>
        }
    }

    componentDidMount() {

        this.loadReactLabels()
        this.updateRssFeeds();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.lastUpdate !== prevProps.lastUpdate) {
            this.updateRssFeeds()
        }
    }

    loadReactLabels() {

        let actions_label = this.props.t('global.actions', {framework: "react-i18next"})

        this.setState({
            columns: [
                {
                    accessor: "id",
                    Header: "ID",
                    maxWidth: 50,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "rss_feed_status",
                    Header: "Status",
                    maxWidth: 100,
                    sortable: true,
                    filterable: false,
                    Cell: row => (
                        <div className="center">
                            <Badge fill="true" style={row.value === 1 ? {
                                background: '#87cb16',
                                borderRadius: '2px',
                                lineHeight: "2"
                            } : {background: '#545557', borderRadius: '2px', lineHeight: "2"}}>
                                {
                                    row.value === 1 ? 'Active' : 'Disabled'
                                }
                            </Badge>
                        </div>
                    )
                },
                {
                    accessor: "rss_feed_name",
                    Header: "rss_feed_name",
                    maxWidth: 250,
                    sortable: true,
                    filterable: false
                },
                {
                    accessor: "rss_category_name",
                    Header: "rss_category_name",
                    maxWidth: 150,
                    sortable: false,
                    filterable: false
                },
                {
                    Header: actions_label,
                    maxWidth: 200,
                    sortable: false,
                    filterable: false,
                    accessor: "id",
                    Cell: row => (
                        <div className="actions-right">
                            {this.setHelperButton(row.value)}
                            {this.setDeleteButton(row.value)}
                        </div>
                    )
                }
            ],
        });
    }

    updateRssFeeds() {

        this.setState({loading: true});

        let myState = this.props.listState;
        let dataUrl = process.env.REACT_APP_API_URL + "/Rss";

        if (myState === "removed") {
            dataUrl = process.env.REACT_APP_API_URL + "/Rss/deleted";
        }

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token
            }
        };

        apiClient.get(dataUrl, axiosConfig)
            .then(res => {
                const data = res.data;
                const loading = false;
                this.setState({data, loading});
            })
            .catch(error => {
                this.setState({loading: false});
                console.log(error);
            });
    }

    //BUTTONS
    setHelperButton(rss_feed_id) {

        if (this.props.listState === "removed") {
            return (<OverlayTrigger placement="top" overlay={this.state.restore_tooltip}>
                <Button
                    onClick={() => this.setState({rss_feed_id: rss_feed_id, showRestoreModal: true})}

                    bsStyle="warning"
                    simple
                    icon
                >
                    <i className="fa fa-repeat"/>
                </Button>
            </OverlayTrigger>)
        } else {
            return (<OverlayTrigger placement="top" overlay={this.state.edit_tooltip}>
                <Button
                    onClick={() => {
                        this.setState({rss_feed_id: rss_feed_id})
                        this.setRedirect();
                    }}

                    bsStyle="info"
                    simple
                    icon
                >
                    <i className="fa fa-edit"/>
                </Button>
            </OverlayTrigger>)
        }

    }

    setDeleteButton(rss_feed_id) {

        return (<OverlayTrigger placement="top" overlay={this.state.remove_tooltip}>
            <Button
                onClick={() => this.setState({rss_feed_id: rss_feed_id, showDeleteModal: true})}

                bsStyle="danger"
                simple
                icon
            >
                <i className="fa fa-times"/>
            </Button>
        </OverlayTrigger>)

    }

    //ACTIONS
    restoreRss(rss_feed_id) {

        const deleteURL = process.env.REACT_APP_API_URL + "/Rss/restore/" + rss_feed_id;

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token
            }
        };

        apiClient.delete(deleteURL, axiosConfig)
            .then((res) => {
                this.updateRssFeeds();
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            })


    }

    deleteRss(rss_feed_id) {

        const deleteURL = process.env.REACT_APP_API_URL + "/Rss/" + rss_feed_id;

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token
            }
        };

        apiClient.delete(deleteURL, axiosConfig)
            .then((res) => {
                this.updateRssFeeds();
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            })


    }

    //MODALS
    setRestoreModal = (id, value, action) => {

        this.setState({
            showRestoreModal: value

        })

        if (action === "restore") {
            this.restoreRss(id);
        }
    }
    setDisplayDeleteModal = (id, value, action) => {

        this.setState({
            showDeleteModal: value
        })

        if (action === "delete") {
            this.deleteRss(id)
        }
    }
    renderRestoreModal = () => {

        if (this.state.showRestoreModal) {
            //console.log("Clicked Restore Modal...");
            return <ModalRestore
                headerMessage={"Restore category"}
                bodyMessage={"this action will restore the category to the list of active categories but in disabled state"}
                handlerFromParent={this.setRestoreModal}
                handlerID={this.state.rss_feed_id}
            />
        }
    }
    renderDeleteModal = () => {

        let bodyMessageVar = "this action will disable the rss and move it to removed state. This action can be undone";

        if (this.props.listState === "removed") {
            bodyMessageVar = "this action will permanently delete the rss and there is no way to restore the state";
        }

        if (this.state.showDeleteModal) {
            return <ModalDelete
                headerMessage={"Delete Rss feed"}
                bodyMessage={bodyMessageVar}
                handlerFromParent={this.setDisplayDeleteModal}
                handlerID={this.state.rss_feed_id}
            />
        }
    }

    render() {
        return (
            <div>
                {this.renderRedirect()}
                {this.renderRestoreModal()}
                {this.renderDeleteModal()}

                <Card
                    content={
                        <div>
                            <Grid fluid>
                                <Row>
                                    <Col md={12}>
                                        <div className="pull-left">
                                            <h5>
                                                {this.props.listName}
                                            </h5>
                                        </div>
                                    </Col>
                                </Row>
                            </Grid>

                            <legend/>

                            <ReactTableV6Simple
                                data={this.state.data}
                                loading={this.state.loading}
                                columns={this.state.columns}
                                defaultPageSize={10}
                            />

                        </div>
                    }
                />


            </div>
        );

    }
}

function mapStateToProps(state) {

    const {users, authentication} = state;
    const {user} = authentication;
    return {
        user,
        users
    };
}

const connectedDataRssFeeds = connect(mapStateToProps)(DataRssFeeds);
const connectedDataRssFeedsTrans = withNamespaces('common')(connectedDataRssFeeds);
export {connectedDataRssFeedsTrans as DataRssFeeds};